import { ChangeDetectionStrategy, Component, Input,  OnInit } from "@angular/core";
import { Utilities } from "@tylertech/shared-module";
import { KeyValue } from "@tylertech/tyler-api-types";

const ALLOWED_STATIC_ATTRS = new Set(["type", "use-forge"]);
const ALLOWED_SCRIPT_NAMES = ["charts.js"];

@Component({
    selector: "metadata-script",
    templateUrl: "./metadataScript.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MetadataScriptComponent implements OnInit
{
    @Input() private readonly model: Readonly<KeyValue[]>;

    scriptContainerId: string;
    ngOnInit(): void
    {
        const self = this;
        this.scriptContainerId = Utilities.generateRandomGuid();
        requestAnimationFrame(() =>
        {
            const scriptContainer = document.getElementById(self.scriptContainerId);
            if (Utilities.IsNullOrUndefined(scriptContainer) || Utilities.IsNullOrUndefined(self.model))
                return;
            const scriptElement = document.createElement("script");
            scriptElement.setAttribute("type", "text/javascript");
            for (const attr of self.model)
            {
                if (!self.isAllowedAttribute(attr.Key, attr.Value))
                    continue;
                scriptElement.setAttribute(attr.Key, attr.Value);
            }
            scriptContainer.appendChild(scriptElement);
        });
    }

    private isAllowedAttribute(key: string, value: string): boolean
    {
        if (Utilities.IsNullOrUndefinedOrEmpty(key))
            return false;
        const normalizedKey = key.toLowerCase();
        if (normalizedKey.startsWith("data-") || ALLOWED_STATIC_ATTRS.has(normalizedKey))
            return true;
        if (normalizedKey === "src")
            return this.isAllowedScriptSource(value);
        return false;
    }

    private isAllowedScriptSource(value: string): boolean
    {
        if (Utilities.IsNullOrUndefinedOrEmpty(value))
            return false;
        let url: URL;
        try
        {
            url = new URL(value);
        }
        catch (e)
        {
            return false;
        }

        if (url.protocol !== "http:" && url.protocol !== "https:")
            return false;

        const fileName = (url.pathname.split("/").pop() ?? "").toLowerCase();
        return ALLOWED_SCRIPT_NAMES.includes(fileName);
    }
}
